<dark-button class="feedback-mobile-button">
    <div class="feedback-mobile-button__text">{{ TEXTS.FEEDBACK.leaveFeedback }}</div>
</dark-button>
